import { getDefaultStatisticItem } from '../../utils/utils'

export default {
  statisticScheme: {
    'WICKETS': getDefaultStatisticItem(),
    '1_RUN': getDefaultStatisticItem(),
    '2_RUN': getDefaultStatisticItem(),
    '4_RUN': getDefaultStatisticItem(),
    '6_RUN': getDefaultStatisticItem(),
    '7_RUN': getDefaultStatisticItem(),
    '8_RUN': getDefaultStatisticItem(),
    '9_RUN': getDefaultStatisticItem(),
    'WIDE': getDefaultStatisticItem('e-cricket.wide'),
    'DOT_BALL': getDefaultStatisticItem('e-cricket.dot-ball'),
    '3_RUN': getDefaultStatisticItem(),
    '5_RUN': getDefaultStatisticItem(),
    'NO_BALL': getDefaultStatisticItem('e-cricket.no-ball')
  },
  statisticEvents: {
    'WICKETS': ['WICKETS', 'WICKETS_SENDABLE'],
    '1_RUN': ['1_RUN', '1_WIDE', '1_RUN_OUT', '1_NO_BALL'],
    '2_RUN': ['2_RUN', '2_WIDE', '2_RUN_OUT', '2_NO_BALL'],
    '4_RUN': ['4_RUN', '4_WIDE', '4_RUN_OUT', '4_NO_BALL'],
    '6_RUN': ['6_RUN', '6_WIDE', '6_RUN_OUT', '6_NO_BALL'],
    '7_RUN': ['7_RUN', '7_WIDE', '7_RUN_OUT', '7_NO_BALL'],
    '8_RUN': ['8_RUN', '8_WIDE', '8_RUN_OUT', '8_NO_BALL'],
    '9_RUN': ['9_RUN', '9_WIDE', '9_RUN_OUT', '9_NO_BALL'],
    'WIDE': ['WIDE', 'WIDE_WITH_RUN'],
    'DOT_BALL': 'DOT_BALL',
    '3_RUN': ['3_RUN', '3_WIDE', '3_RUN_OUT', '3_NO_BALL'],
    '5_RUN': ['5_RUN', '5_WIDE', '5_RUN_OUT', '5_NO_BALL'],
    'NO_BALL': ['NO_BALL', 'NO_BALL_WITH_RUN']
  },
  statisticOrder: [
    'WICKETS',
    '1_RUN',
    '2_RUN',
    '4_RUN',
    '6_RUN',
    'WIDE',
    'DOT_BALL',
    '3_RUN',
    '5_RUN',
    'NO_BALL',
    '7_RUN',
    '8_RUN',
    '9_RUN',
  ],
  statisticFunction (event) {
    getCommonPossessionStatistic.bind(this)(event)
  }
}

function updateFunction ({ period, team, type, value }) {
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'possession',
    period,
    team,
    type,
    value
  })
}

function getCommonPossessionStatistic (event) {
  const updateStatistic = updateFunction.bind(this)
  const {
    isTimerStoped,
    getActiveSide,
    getMatchPeriods,
    getCurrentPeriod
  } = this

  if (!getCurrentPeriod) return

  const { EventCode, Playtime, GamePeriod } = event
  const { overriddenType } = getMatchPeriods[getCurrentPeriod]
}
